import { Relationship } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { firebaseTimestampToDate } from './firebase-timestamp-to-date';

export const relationshipConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): Relationship => {
    const data = snapshot.data() as Record<string, unknown>;
    return {
      ...data,
      createdAt: firebaseTimestampToDate(data.createdAt as Date),
      updatedAt: firebaseTimestampToDate(data.updatedAt as Date),
    } as Relationship;
  },
  toFirestore: (relationship: Relationship) => relationship,
};
